import { useState, useEffect } from "react";
import { Image as ImageIcon, FileAudio, FileVideo, X, RefreshCw } from "lucide-react";

const ICONS = { image: ImageIcon, audio: FileAudio, video: FileVideo };

function Field({ label, required, children }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
    </div>
  );
}

export default function MediaDropField({
  label,
  kind = "image", // "image" | "audio" | "video"
  accept,
  existingUrl,   // رابط الملف الحالي وقت التعديل
  file,          // الملف الجديد المختار (أو null)
  onChange,      // (file|null) => void
  cleared,       // true لو اتمسحت الصورة الحالية (images بس)
  onClear,       // () => void
  required = false,
}) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const Icon = ICONS[kind] || ImageIcon;
  const isImage = kind === "image";

  useEffect(() => {
    if (!file) return setPreviewUrl(null);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const displayUrl = previewUrl || (!cleared ? existingUrl : null);

  if (displayUrl && isImage) {
    return (
      <Field label={label} required={required}>
        <div className="relative inline-block">
          <img src={displayUrl} alt="Preview" className="w-full max-h-48 object-contain rounded-lg border border-gray-300" />
          <button
            type="button"
            onClick={() => { onChange(null); onClear?.(); }}
            className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </Field>
    );
  }

  if (!isImage && (file || existingUrl)) {
    return (
      <Field label={label} required={required}>
        <div className="flex items-center justify-between border border-gray-300 rounded-lg px-3 py-2 bg-gray-50">
          <span className="text-sm text-gray-600 truncate flex items-center gap-2">
            <Icon className="w-4 h-4 text-gray-400" />
            {file ? file.name : "الملف الحالي محفوظ"}
          </span>
          <label className="text-indigo-600 hover:text-indigo-700 text-xs font-medium cursor-pointer flex items-center gap-1 flex-shrink-0">
            <RefreshCw className="w-3.5 h-3.5" />
            استبدال
            <input type="file" accept={accept} className="hidden"
              onChange={(e) => e.target.files[0] && onChange(e.target.files[0])} />
          </label>
        </div>
      </Field>
    );
  }

  return (
    <Field label={label} required={required}>
      <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg py-6 cursor-pointer hover:border-indigo-400 transition-colors">
        <Icon className="w-8 h-8 text-gray-400 mb-2" />
        <span className="text-sm text-gray-500">اضغط لرفع {label}</span>
        <input type="file" accept={accept} className="hidden"
          onChange={(e) => e.target.files[0] && onChange(e.target.files[0])} />
      </label>
    </Field>
  );
}